(()=>{
  function init(root){
    if(root.dataset.ready)return;
    root.dataset.ready='1';
    const slides=[...root.querySelectorAll('[data-rk-slide]')];
    const nav=root.querySelector('[data-nav]');
    const dots=root.querySelector('[data-dots]');
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
    const interval=Math.max(2,Number(root.dataset.seconds||4))*1000;
    const pauseInteraction=root.dataset.pauseInteraction==='true';
    let active=0,timer=null,hovered=false,focused=false,editorSelecting=false;
    const shouldRotate=()=>root.dataset.auto==='true'&&slides.length>1&&!reduced.matches&&!document.hidden&&!editorSelecting&&!(pauseInteraction&&focused);
    function schedule(){
      clearTimeout(timer);
      timer=null;
      if(shouldRotate())timer=window.setTimeout(()=>go(active+1),interval);
    }
    const dotButtons=[];
    function go(index){
      active=(index+slides.length)%slides.length;
      slides.forEach((slide,i)=>{
        const selected=i===active;
        slide.classList.toggle('is-active',selected);
        slide.inert=!selected;
        slide.setAttribute('aria-hidden',String(!selected));
      });
      dotButtons.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===active)));
      schedule();
    }
    if(nav&&slides.length<2)nav.hidden=true;
    if(dots){
      slides.forEach((slide,i)=>{
        const dot=document.createElement('button');
        dot.type='button';
        dot.className='rk-editorial__dot';
        dot.setAttribute('aria-label','View slide '+(i+1)+': '+(slide.dataset.slideHeading||'Jewellery'));
        dot.addEventListener('click',()=>go(i));
        dots.append(dot);
        dotButtons.push(dot);
      });
    }
    // Only keyboard focus pauses autoplay. Touching/swiping a slide must not stop its timer.
    let keyboardFocus=false;
    root.addEventListener('pointerdown',()=>{
      keyboardFocus=false;
      if(focused){focused=false;schedule();}
    },{passive:true});
    if(pauseInteraction){
      root.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){hovered=true;schedule();}});
      root.addEventListener('pointerleave',e=>{if(e.pointerType==='mouse'){hovered=false;schedule();}});
      root.addEventListener('keydown',e=>{
        if(e.key==='Tab'||e.key==='ArrowLeft'||e.key==='ArrowRight'){
          keyboardFocus=true;
          if(!focused){focused=true;schedule();}
        }
      });
      root.addEventListener('focusin',()=>{if(keyboardFocus){focused=true;schedule();}});
      root.addEventListener('focusout',e=>{
        if(!e.relatedTarget||!root.contains(e.relatedTarget)){focused=false;schedule();}
      });
    }
    root.addEventListener('keydown',e=>{
      if(e.key==='ArrowLeft'){e.preventDefault();go(active-1);}
      if(e.key==='ArrowRight'){e.preventDefault();go(active+1);}
    });
    let touchX=null;
    root.addEventListener('touchstart',e=>{touchX=e.touches[0]?.clientX??null;},{passive:true});
    root.addEventListener('touchend',e=>{
      if(touchX===null)return;
      const dx=(e.changedTouches[0]?.clientX??touchX)-touchX;
      touchX=null;
      if(Math.abs(dx)>55)go(active+(dx<0?1:-1));
    },{passive:true});
    document.addEventListener('visibilitychange',schedule);
    reduced.addEventListener?.('change',schedule);
    if(window.Shopify?.designMode){
      document.addEventListener('shopify:block:select',e=>{
        const index=slides.findIndex(s=>s.dataset.blockId===e.detail?.blockId);
        if(index!==-1){editorSelecting=true;go(index);}
      });
      document.addEventListener('shopify:block:deselect',()=>{editorSelecting=false;schedule();});
    }
    go(0);
  }
  function boot(from=document){from.querySelectorAll('[data-rk-hero]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot());
  else boot();
  document.addEventListener('shopify:section:load',e=>boot(e.target));
})();